import { css } from '@emotion/css';
import { actImageUrl, commonGenresStyle } from 'Shared/frontend/eventPosters/MusicPoster';
import { genreList } from 'Shared/common/Macros';
import { Show } from 'solid-js';
import { eventNameStyle } from 'Shared/frontend/eventPosters/separated/Utils';
import { poster } from 'Shared/frontend/SettingsProvider';


export function FourActs(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'fourActs');

	const posterStyle = () => css({
		marginTop: 12,
		display: 'grid',
		gridTemplateColumns: '50% 50%',
		gap: '4px 6px',
		textAlign: 'center'
	});

	const eventSize = () => s().nameFontSize ?? theme().name.fontSize;
	const artistSize = () => s().artistNamesFontSize ?? theme().artistNames.fontSize;

	const hide = () => s()?.hide ?? [];
	const showName = () => P.name && ! s().hide?.includes('name');

	return (
		<div>
			<div class={css(eventNameStyle(),{fontSize:eventSize()})}>
				<Show when={showName()}>
					{P.name}
				</Show>
			</div>

			<div class={posterStyle()}>
				<Artist {...P.lineup[0]} hide={hide()} fontSize={artistSize()} />
				<Artist {...P.lineup[1]} hide={hide()} fontSize={artistSize()} />
				<Artist {...P.lineup[2]} hide={hide()} fontSize={artistSize()} />
				<Artist {...P.lineup[3]} hide={hide()} fontSize={artistSize()} />
			</div>
		</div>
	);
}

function Artist(P)
{
	const artistNameStyle = () => css({
		width: '100%',
		fontSize: P.fontSize
	});

	const artistStyle = () => css({
		minWidth: 0
	});

	const artistDetailsStyle = () => css({
		padding: 5
	});

	const pressShotStyle = () => css({
		maxWidth: '100%',
	});

	const genresStyle = () => css(commonGenresStyle(), {
		fontSize: '0.6em',
		lineHeight: '1.5em'  //XXX MOSTLY JUST SPACING. THERE ARE BETTER WAYS....
	});


	return (
		<div class={artistStyle()}>
			<img class={pressShotStyle()} src={actImageUrl(P.image)} width={132} height={88} />

			<div class={artistDetailsStyle()}>
				<Show when={!P.hide.includes('artistName') && P.name}>
					<div class={artistNameStyle()}>{P.name}</div>
				</Show>
				<Show when={!P.hide.includes('artistGenres') && P.mainGenre}>
					<div class={genresStyle()}>{ genreList(P) }</div>
				</Show>
			</div> 
		</div>
	);
}

